import {makeAutoObservable} from 'mobx';
import {fromPromise, IPromiseBasedObservable} from 'mobx-utils';
import {ArticleType} from '@wp-content-publisher/typings-lib';
import {searchArticle} from '../api/search-article.ts';

class ArticleSearchTableStore {

    list?: IPromiseBasedObservable<ArticleType[]>;

    constructor() {
        makeAutoObservable(this);
    }

    getSearchAction = (search: string) => {
        this.list = fromPromise(searchArticle(search));
    }
}

const articleSearchTableStore = new ArticleSearchTableStore();
export {articleSearchTableStore};